/**
 * Order Events reducer
 */
import { produce } from 'immer';

import { FAILED, LOADED, LOADING, NONE } from '../../../constants/Status';

import * as t from './actionTypes';

const initialState = {
  entity: null,
  error: null,
  status: NONE,
};

/**
 * Order Events root reducer
 *
 * @param {object} state initial or previous state of data
 * @param {object} action the action object
 *
 * @return {object}
 */
export default function root(state = initialState, action = {}) {
  switch (action.type) {
    case t.ORDER_DETAIL_REQUESTED:
      // Mark the state as "loading" so we can show a spinner or something.
      // Also, reset any errors. We're starting fresh.
      return produce(state, draft => {
        draft.status = LOADING;
        draft.error = null;
      });
    case t.ORDER_DETAIL_SUCCEEDED:
      // All done: set loading to "false".
      // Also, replace the items with the ones from the server
      return produce(state, draft => {
        draft.status = LOADED;
        draft.error = null;
        draft.entity = action.payload.order;
      });
    case t.ORDER_DETAIL_FAILED:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere.
      return produce(state, draft => {
        draft.entity = null;
        draft.status = FAILED;
        draft.error = action.payload;
      });
    default:
      return state;
  }
}
